import {Component, Input, OnInit} from '@angular/core';
import {UtilsService} from '../../../core/utils/utils.service';
import {LotMarchePdLumpCaDto} from '../../../core/dtos/gerstion-marche/lot-marche-pd-lump-ca-dto';

@Component({
    selector: 'yo-info-lotmarche-article',
    templateUrl: './info-lotmarche-article.component.html',
    styleUrls: ['./info-lotmarche.component.scss'],
    standalone: false
})
export class InfoLotmarcheArticleComponent implements OnInit {

  // le composant ne s'affiche que si l'unité de production correspont au lotmarche
  @Input() uniteDeProductionId: number;
  @Input() lotMarchePdLumpCa: LotMarchePdLumpCaDto;
  /** Indique si l'UDP de la liaison lot marché doit être vérifiée avec l'udp de l'écran courant*/
  @Input() checkUniteDeProduction: boolean = true;


  constructor(public utils: UtilsService) {
  }

  ngOnInit(): void {
  }


  isArticleLotMarche() {

    return !this.utils.isNullOrEmpty(this.lotMarchePdLumpCa)
      && (!this.checkUniteDeProduction ||
        this.lotMarchePdLumpCa.lmupUdpId === this.uniteDeProductionId);
  }
}
